<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
        </div>

        <!-- Form 1 -->
        <div>
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              1. ข้อมูลหัวหน้าโครงการและคณะ
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button
                theme="6"
                :disabled="team_head.length >= 5"
                @onClick="addMoreTeam('ข้อมูลหัวหน้าโครงการและคณะ', team_head)"
            >
              + เพิ่มข้อมูลคณะ
            </Button>
          </div>
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ชื่อ - สกุล
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_p1_name"
                  @onChange="setFormField('s2_p1_name', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ตำเเหน่ง
              </div>
              <AutoBox
                  theme="3"
                  :items="masterData.positions"
                  item-text="name"
                  item-value="name"
                  :value="form.s2_p1_position"
                  @onChange="setFormField('s2_p1_position', $event)"
              ></AutoBox>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                หน่วยงาน
              </div>
              <AutoBox
                  theme="3"
                  :items="masterData.institutes"
                  item-text="name"
                  item-value="name"
                  :value="form.s2_p1_dep"
                  @onChange="setFormField('s2_p1_dep', $event)"
              ></AutoBox>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">
                สังกัด
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_p1_org"
                  @onChange="setFormField('s2_p1_org', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ที่อยู่
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_p1_addr"
                  @onChange="setFormField('s2_p1_addr', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="flex-center gap-16">
                <div class="flex xs6">
                  <div class="mb-1 black--text">
                    เบอร์โทรศัพท์
                  </div>
                  <TextField
                      placeholder="09XXXXXXXX"
                      theme="3"
                      input-type="number"
                      :value="form.s2_p1_phone"
                      @onChange="setFormField('s2_p1_phone', $event)"
                  ></TextField>
                </div>
                <div class="flex xs6">
                  <div class="mb-1 black--text">
                    E-mail
                  </div>
                  <TextField
                      theme="3"
                      :rules="emailRules"
                      :value="form.s2_p1_email"
                      @onChange="setFormField('s2_p1_email', $event)"
                  ></TextField>
                </div>
              </div>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ความเชี่ยวชาญ
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_p1_expertise"
                  @onChange="setFormField('s2_p1_expertise', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="flex-center gap-16">
                <div class="flex xs6">
                  <div class="mb-1 black--text">
                    สัดส่วนการทำงาน
                  </div>
                  <TextField
                      theme="3"
                      :value="form.s2_p1_resp"
                      @onChange="setFormField('s2_p1_resp', $event)"
                  ></TextField>
                </div>
                <div class="flex xs6">
                  <div class="mb-1 black--text">
                    ชั่วโมงการทำงาน
                  </div>
                  <TextField
                      theme="3"
                      :value="form.s2_p1_resp_hrs"
                      @onChange="setFormField('s2_p1_resp_hrs', $event)"
                  ></TextField>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </divcard>

    <!-- Team 1 -->
    <div class="px-5">
      <divcard
          v-for="(team, i) in team_head"
          :key="i"
          class="mb-3"
      >
        <div class="black--text txt-m-head mb-3">1.{{ i + 1 }} ข้อมูลคณะ</div>
        <v-btn
            icon
            absolute
            top
            right
            style="z-index: 99"
            @click="delTeam(i, team_head)"
        >
          <Iconify
              class="font-18"
              style="color: #b1b1b1"
              icon="mdi:delete"
          />
        </v-btn>
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ชื่อ - สกุล</div>
            <TextField
                theme="3"
                :value="team.s2_p1_name"
                @onChange="setTeamField('s2_p1_name', team_head, i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">ตำเเหน่ง</div>
            <AutoBox
                theme="3"
                :items="masterData.positions"
                item-text="name"
                item-value="name"
                :value="team.s2_p1_position"
                @onChange="setTeamField('s2_p1_position', team_head, i, $event)"
            ></AutoBox>
          </div>
        </div>

        <!-- Form 1 #line2 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">หน่วยงาน</div>
            <AutoBox
                theme="3"
                :items="masterData.institutes"
                item-text="name"
                item-value="name"
                :value="team.s2_p1_dep"
                @onChange="setTeamField('s2_p1_dep', team_head, i, $event)"
            ></AutoBox>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">สังกัด</div>
            <TextField
                theme="3"
                :value="team.s2_p1_org"
                @onChange="setTeamField('s2_p1_org', team_head, i, $event)"
            ></TextField>
          </div>
        </div>

        <!-- Form 1 #line3 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ที่อยู่</div>
            <TextField
                theme="3"
                :value="team.s2_p1_addr"
                @onChange="setTeamField('s2_p1_addr', team_head, i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="flex-center gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">เบอร์โทรศัพท์</div>
                <TextField
                    theme="3"
                    input-type="number"
                    :value="team.s2_p1_phone"
                    @onChange="setTeamField('s2_p1_phone', team_head, i, $event)"
                ></TextField>
              </div>
              <div class="flex xs6">
                <div class="mb-1 black--text">E-mail</div>
                <TextField
                    theme="3"
                    :rules="emailRules"
                    :value="team.s2_p1_email"
                    @onChange="setTeamField('s2_p1_email', team_head, i, $event)"
                ></TextField>
              </div>
            </div>
          </div>
        </div>

        <!-- Form 1 #line4 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ความเชี่ยวชาญ</div>
            <TextField
                theme="3"
                :value="team.s2_p1_expertise"
                @onChange="setTeamField('s2_p1_expertise', team_head, i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="flex-center gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">
                  สัดส่วนการทำงาน
                </div>
                <TextField
                    theme="3"
                    :value="team.s2_p1_resp"
                    @onChange="setTeamField('s2_p1_resp', team_head, i, $event)"
                ></TextField>
              </div>
              <div class="flex xs6">
                <div class="mb-1 black--text">
                  ชั่วโมงการทำงาน
                </div>
                <TextField
                    theme="3"
                    :value="team.s2_p1_resp_hrs"
                    @onChange="setTeamField('s2_p1_resp_hrs', team_head, i, $event)"
                ></TextField>
              </div>
            </div>
          </div>
        </div>
      </divcard>
    </div>

    <!-- Form 2 -->
    <divcard>
      <div class="card-part pt-0">
        <!-- Form 2 -->
        <div>
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              2. ผู้รับผิดชอบโครงการ (Project Manager) (ภาคเอกชน)
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button
                theme="6"
                :disabled="team_manager.length >= 5"
                @onClick="addMoreTeam('ผู้รับผิดชอบโครงการ', team_manager)"
            >
              + เพิ่มข้อมูลผู้รับผิดชอบโครงการ
            </Button>
          </div>
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ชื่อ - สกุล
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_p2_name"
                  @onChange="setFormField('s2_p2_name', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ตำเเหน่ง
              </div>
              <AutoBox
                  theme="3"
                  :items="masterData.positions"
                  item-text="name"
                  item-value="name"
                  :value="form.s2_p2_position"
                  @onChange="setFormField('s2_p2_position', $event)"
              ></AutoBox>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                หน่วยงาน
              </div>
              <AutoBox
                  theme="3"
                  :items="masterData.institutes"
                  item-text="name"
                  item-value="name"
                  :value="form.s2_p2_dep"
                  @onChange="setFormField('s2_p2_dep', $event)"
              ></AutoBox>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">
                สังกัด
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_p2_org"
                  @onChange="setFormField('s2_p2_org', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ที่อยู่
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_p2_addr"
                  @onChange="setFormField('s2_p2_addr', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="flex-center gap-16">
                <div class="flex xs6">
                  <div class="mb-1 black--text">
                    เบอร์โทรศัพท์
                  </div>
                  <TextField
                      placeholder="09XXXXXXXX"
                      theme="3"
                      input-type="number"
                      :value="form.s2_p2_phone"
                      @onChange="setFormField('s2_p2_phone', $event)"
                  ></TextField>
                </div>
                <div class="flex xs6">
                  <div class="mb-1 black--text">
                    E-mail
                  </div>
                  <TextField
                      theme="3"
                      :rules="emailRules"
                      :value="form.s2_p2_email"
                      @onChange="setFormField('s2_p2_email', $event)"
                  ></TextField>
                </div>
              </div>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ความเชี่ยวชาญ
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_p2_expertise"
                  @onChange="setFormField('s2_p2_expertise', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="flex-center gap-16">
                <div class="flex xs6">
                  <div class="mb-1 black--text">
                    สัดส่วนการทำงาน
                  </div>
                  <TextField
                      theme="3"
                      :value="form.s2_p2_resp"
                      @onChange="setFormField('s2_p2_resp', $event)"
                  ></TextField>
                </div>
                <div class="flex xs6">
                  <div class="mb-1 black--text">
                    ชั่วโมงการทำงาน
                  </div>
                  <TextField
                      theme="3"
                      :value="form.s2_p2_resp_hrs"
                      @onChange="setFormField('s2_p2_resp_hrs', $event)"
                  ></TextField>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </divcard>

    <!-- Team 2 -->
    <div class="px-5">
      <divcard
          v-for="(team, i) in team_manager"
          :key="i"
          class="mb-3"
      >
        <div class="black--text txt-m-head mb-3">2.{{ i + 1 }} ชื่อ - สกุล ผู้รับผิดชอบโครงการ</div>
        <v-btn
            icon
            absolute
            top
            right
            style="z-index: 99"
            @click="delTeam(i, team_manager)"
        >
          <Iconify
              class="font-18"
              style="color: #b1b1b1"
              icon="mdi:delete"
          />
        </v-btn>
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ชื่อ - สกุล</div>
            <TextField
                theme="3"
                :value="team.s2_p1_name"
                @onChange="setTeamField('s2_p1_name', team_manager, i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">ตำเเหน่ง</div>
            <AutoBox
                theme="3"
                :items="masterData.positions"
                item-text="name"
                item-value="name"
                :value="team.s2_p1_position"
                @onChange="setTeamField('s2_p1_position', team_manager, i, $event)"
            ></AutoBox>
          </div>
        </div>

        <!-- Form 1 #line2 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">หน่วยงาน</div>
            <AutoBox
                theme="3"
                :items="masterData.institutes"
                item-text="name"
                item-value="name"
                :value="team.s2_p1_dep"
                @onChange="setTeamField('s2_p1_dep', team_manager, i, $event)"
            ></AutoBox>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">สังกัด</div>
            <TextField
                theme="3"
                :value="team.s2_p1_org"
                @onChange="setTeamField('s2_p1_org', team_manager, i, $event)"
            ></TextField>
          </div>
        </div>

        <!-- Form 1 #line3 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ที่อยู่</div>
            <TextField
                theme="3"
                :value="team.s2_p1_addr"
                @onChange="setTeamField('s2_p1_addr', team_manager, i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="flex-center gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">เบอร์โทรศัพท์</div>
                <TextField
                    theme="3"
                    input-type="number"
                    :value="team.s2_p1_phone"
                    @onChange="setTeamField('s2_p1_phone', team_manager, i, $event)"
                ></TextField>
              </div>
              <div class="flex xs6">
                <div class="mb-1 black--text">E-mail</div>
                <TextField
                    theme="3"
                    :rules="emailRules"
                    :value="team.s2_p1_email"
                    @onChange="setTeamField('s2_p1_email', team_manager, i, $event)"
                ></TextField>
              </div>
            </div>
          </div>
        </div>

        <!-- Form 1 #line4 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ความเชี่ยวชาญ</div>
            <TextField
                theme="3"
                :value="team.s2_p1_expertise"
                @onChange="setTeamField('s2_p1_expertise', team_manager, i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="flex-center gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">
                  สัดส่วนการทำงาน
                </div>
                <TextField
                    theme="3"
                    :value="team.s2_p1_resp"
                    @onChange="setTeamField('s2_p1_resp', team_manager, i, $event)"
                ></TextField>
              </div>
              <div class="flex xs6">
                <div class="mb-1 black--text">
                  ชั่วโมงการทำงาน
                </div>
                <TextField
                    theme="3"
                    :value="team.s2_p1_resp_hrs"
                    @onChange="setTeamField('s2_p1_resp_hrs', team_manager, i, $event)"
                ></TextField>
              </div>
            </div>
          </div>
        </div>
      </divcard>
    </div>

    <!-- Form 3 -->
    <divcard>
      <div class="card-part pt-0">
        <!-- Form 3 -->
        <div>
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              3. ผู้รับประสานงาน
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button
                theme="6"
                :disabled="team_coordinate.length >= 5"
                @onClick="addMoreTeam('ผู้รับประสานงาน', team_coordinate)"
            >
              + เพิ่มข้อมูลผู้ประสานงาน
            </Button>
          </div>
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ชื่อ - สกุล
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_pc_name"
                  @onChange="setFormField('s2_pc_name', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ตำเเหน่ง
              </div>
              <AutoBox
                  theme="3"
                  :items="masterData.positions"
                  item-text="name"
                  item-value="name"
                  :value="form.s2_pc_position"
                  @onChange="setFormField('s2_pc_position', $event)"
              ></AutoBox>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                เบอร์โทรศัพท์
              </div>
              <TextField
                  placeholder="09XXXXXXXX"
                  theme="3"
                  input-type="number"
                  :value="form.s2_pc_phone"
                  @onChange="setFormField('s2_pc_phone', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">
                E-mail
              </div>
              <TextField
                  theme="3"
                  :rules="emailRules"
                  :value="form.s2_pc_email"
                  @onChange="setFormField('s2_pc_email', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                หน่วยงาน
              </div>
              <AutoBox
                  theme="3"
                  :items="masterData.institutes"
                  item-text="name"
                  item-value="name"
                  :value="form.s2_pc_dep"
                  @onChange="setFormField('s2_pc_dep', $event)"
              ></AutoBox>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ที่อยู่
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_pc_addr"
                  @onChange="setFormField('s2_pc_addr', $event)"
              ></TextField>
            </div>
          </div>

        </div>

      </div>
    </divcard>

    <!-- Team 3 -->
    <div class="px-5">
      <divcard
          v-for="(team, i) in team_coordinate"
          :key="i"
          class="mb-3"
      >
        <div class="black--text txt-m-head mb-3">3.{{ i + 1 }} ชื่อ - สกุล ผู้รับประสานงาน</div>
        <v-btn
            icon
            absolute
            top
            right
            style="z-index: 99"
            @click="delTeam(i, team_coordinate)"
        >
          <Iconify
              class="font-18"
              style="color: #b1b1b1"
              icon="mdi:delete"
          />
        </v-btn>

        <!-- Form 1 #line1 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ชื่อ - สกุล</div>
            <TextField
                theme="3"
                :value="team.s2_p1_name"
                @onChange="setTeamField('s2_p1_name', team_coordinate, i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">ตำเเหน่ง</div>
            <AutoBox
                theme="3"
                :items="masterData.positions"
                item-text="name"
                item-value="name"
                :value="team.s2_p1_position"
                @onChange="setTeamField('s2_p1_position', team_coordinate, i, $event)"
            ></AutoBox>
          </div>
        </div>

        <!-- Form 1 #line2 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">เบอร์โทรศัพท์</div>
            <TextField
                theme="3"
                input-type="number"
                :value="team.s2_p1_phone"
                @onChange="setTeamField('s2_p1_phone', team_coordinate, i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">E-mail</div>
            <TextField
                theme="3"
                :rules="emailRules"
                :value="team.s2_p1_email"
                @onChange="setTeamField('s2_p1_email', team_coordinate, i, $event)"
            ></TextField>
          </div>
        </div>

        <!-- Form 1 #line3 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">หน่วยงาน</div>
            <AutoBox
                theme="3"
                :items="masterData.institutes"
                item-text="name"
                item-value="name"
                :value="team.s2_p1_dep"
                @onChange="setTeamField('s2_p1_dep', team_coordinate, i, $event)"
            ></AutoBox>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">ที่อยู่</div>
            <TextField
                theme="3"
                :value="team.s2_p1_addr"
                @onChange="setTeamField('s2_p1_addr', team_coordinate, i, $event)"
            ></TextField>
          </div>
        </div>

      </divcard>
    </div>

    <!-- Form 4 -->
    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            4. ข้อมูลภาคเอกชนที่เข้าร่วมทำวิจัยและพัฒนา
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>
          <!-- Form 2 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ชื่อ - สกุล นิติบุคคล/กิจการ
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_p3_prv_org_name"
                  @onChange="setFormField('s2_p3_prv_org_name', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ที่อยู่
              </div>
              <TextField
                  theme="3"
                  :value="form.s2_p3_prv_org_address"
                  @onChange="setFormField('s2_p3_prv_org_address', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 2 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="flex-center gap-16">
                <div class="flex xs6">
                  <div class="mb-1 black--text">
                    เบอร์โทรศัพท์
                  </div>
                  <TextField
                      placeholder="09XXXXXXXX"
                      theme="3"
                      input-type="number"
                      :value="form.s2_p3_prv_org_phone"
                      @onChange="setFormField('s2_p3_prv_org_phone', $event)"
                  ></TextField>
                </div>
                <div class="flex xs6">
                  <div class="mb-1 black--text">
                    E-mail
                  </div>
                  <TextField
                      theme="3"
                      :rules="emailRules"
                      :value="form.s2_p3_prv_org_email"
                      @onChange="setFormField('s2_p3_prv_org_email', $event)"
                  ></TextField>
                </div>
              </div>
            </div>
          </div>

          <!-- Form 2 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                รูปแบบของธุรกิจ/ลักษณะกิจการ (แบบย่อ)
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_p3_prv_org_type"
                  @onChange="setFormField('s2_p3_prv_org_type', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>

      </div>

      <div class="card-part">
        <!-- Form 2 #line4 -->
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              รูปแบบผลิตภัณฑ์ (ผลิตภัณฑ์ใหม่/กระบวนการผลิตใหม่ มีความโดดเด่นและแตกต่างจากที่มีอยู่ในตลาด)
            </div>
            <Wysiwyg
                theme="3"
                :value="form.s2_p3_prv_org_prod_design"
                @onChange="setFormField('s2_p3_prv_org_prod_design', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>

      <div class="card-part">
        <!-- Form 2 #line5 -->
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              ความพร้อมของเอกชนในการร่วมวิจัยและพัฒนา
            </div>
            <Wysiwyg
                theme="3"
                :value="form.s2_p3_prv_org_ready"
                @onChange="setFormField('s2_p3_prv_org_ready', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>

      <div class="card-part">
        <!-- Form 2 #line5 -->
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              ศักยภาพของภาคเอกชนในการนำเทคโนโลยีไปต่อยอดทางธุรกิจ
            </div>
            <Wysiwyg
                theme="3"
                :value="form.s2_p3_prv_org_potent"
                @onChange="setFormField('s2_p3_prv_org_potent', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>

      <div class="card-part">
        <!-- Form 2 #line5 -->
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              แนวโน้มที่เอกชนจะนำงานวิจัยใช้ในการพัฒนาศักยภาพทางธุรกิจหรือเข้าร่วม Platform อื่นๆ
              ของอุทยานวิทยาศาสตร์เพื่อทำวิจัยในอนาคต
            </div>
            <TextArea
                theme="3"
                :value="form.s2_p3_prv_org_trend"
                @onChange="setFormField('s2_p3_prv_org_trend', $event)"
            ></TextArea>
          </div>
        </div>
      </div>

      <div class="card-part">
        <!-- Form 2 #line5 -->
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-3 black--text">
              สัดส่วนการลงทุนของเอกชนในการร่วมโครงการ
              <span class="theme-color-seven txt-normal">(ข้อมูลมาจากส่วนที่3)</span>
            </div>

            <div>
              <ul>
                <li>
                  <div class="d-flex justify-space-between" style="gap: 16px">
                    <div class="black--text pt-2">ภาคเอกชนสนับสนุนจำนวน</div>
                    <div class="d-flex justify-end" style="gap: 16px">
                      <TextField
                          readonly
                          style="max-width: 200px"
                          theme="3"
                          :value="formatNumber(private_sum,2)"
                      ></TextField>
                      <div class="black--text pt-2">บาท</div>
                      <div class="black--text pt-2" style="min-width: 80px; max-width: 80px">โดยแบ่งเป็น</div>
                      <div style="min-width: 200px; max-width: 200px"></div>
                    </div>
                  </div>

                  <ul style="list-style: none">
                    <li>
                      <div class="d-flex justify-space-between" style="gap: 16px">
                        <div class="pt-2">ส่วนที่เป็นตัวเงิน(In-cash)จำนวน</div>
                        <div class="d-flex justify-end" style="gap: 16px">
                          <TextField
                              readonly
                              style="max-width: 200px"
                              theme="3"
                              :value="formatNumber(incash_sum,2)"
                          ></TextField>
                          <div class="pt-2">บาท</div>
                          <div class="pt-2" style="min-width: 80px; max-width: 80px">คิดเป็นร้อยละ</div>
                          <TextField
                              readonly
                              style="max-width: 200px"
                              theme="3"
                              :value="incash_percent"
                          ></TextField>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="d-flex justify-space-between" style="gap: 16px">
                        <div class="pt-2">ส่วนที่เป็นสิ่งของสนับสนุน(In-Kind)จำนวน</div>
                        <div class="d-flex justify-end" style="gap: 16px">
                          <TextField
                              readonly
                              style="max-width: 200px"
                              theme="3"
                              :value="formatNumber(inkind_sum,2)"
                          ></TextField>
                          <div class="pt-2">บาท</div>
                          <div class="pt-2" style="min-width: 80px; max-width: 80px">คิดเป็นร้อยละ</div>
                          <TextField
                              readonly
                              style="max-width: 200px"
                              theme="3"
                              :value="inkind_percent"
                          ></TextField>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
                <li>
                  <div class="d-flex justify-space-between" style="gap: 16px">
                    <div class="black--text pt-2">อุทยานวิทยาศาสตร์ภูมิภาค สนับสนุนจำนวน</div>
                    <div class="d-flex justify-end" style="gap: 16px">
                      <TextField
                          readonly
                          style="max-width: 200px"
                          theme="3"
                          :value="formatNumber(scipark_sum,2)"
                      ></TextField>
                      <div class="black--text pt-2">บาท</div>
                      <div class="black--text pt-2" style="min-width: 80px; max-width: 80px">คิดเป็นร้อยละ</div>
                      <TextField
                          readonly
                          style="max-width: 200px"
                          theme="3"
                          :value="scipark_percent"
                      ></TextField>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!-- Form 5 -->
    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            5. กิจการของภาคเอกชนที่เข้าร่วมโครงการมีความเกี่ยวข้องในกลุ่มอุตสาหกรรม
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <AutoBox
                  theme="3"
                  :items="industryBusinesses"
                  multiple
                  chips
                  deletable-chips
                  :value="form.s2_p4_prv_org_involved"
                  @onChange="setFormField('s2_p4_prv_org_involved', $event)"
              ></AutoBox>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <TextArea
                  theme="3"
                  placeholder="ระบุเพิ่มเติม"
                  :value="form.s2_p4_prv_org_other"
                  @onChange="setFormField('s2_p4_prv_org_other', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!-- Form 6 -->
    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            6. ที่มาและความสำคัญ
          </div>
          <Wysiwyg
              theme="3"
              :value="form.s2_p7_source"
              @onChange="setFormField('s2_p7_source', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <!-- From 7 -->
    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            7. วัตถุประสงค์ (ระบุข้อมูลที่ใช้วัดผลความสำเร็จเมื่อเสร็จโครงการ
            แสดงทั้งในรูปแบบของเชิงปริมาณและคุณภาพให้มีความสอดคล้องกับ วัตถุประสงค์ของโครงการ)
          </div>
          <Wysiwyg
              theme="3"
              height="100"
              :value="form.s2_p8_objective"
              @onChange="setFormField('s2_p8_objective', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <!-- From 8 -->
    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            8. ศักยภาพและความพร้อมในการดำเนินโครงการ
            <div class="theme-color-seven txt-normal" style="text-indent: 16px">
              (โปรดกรอกข้อมูลให้ครบทุกข้อ)
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความเข้มข้นของการใช้ ผลงานวิจัย ต้นแบบ ที่มีผลพิสูจน์ในระดับห้องปฏิบัติการ
                ระดับของเทคโนโลยี(ที่สามารถใช้อ้างอิงได้ เช่น ระดับ TRL)
                และความรู้ ความเชี่ยวชาญของบุคลากรที่มีอยู่ของมหาวิทยาลัยในการสนับสนุนการวิจัยและพัฒนาร่วมกับภาคเอกชน
                (อธิบายในลักษณะของเทคโนโลยีที่ใช้ เป็นรูปแบบ เทคโนโลยีที่เหมาะสม (Appropriate Technology)
                ซึ่งเป็นเทคโนโลยีที่มีความพร้อมในการดำเนินงานในลักษณะที่มีความพร้อมสู่การนำไปใช้จริง
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.s2_p5_intensity"
                  @onChange="setFormField('s2_p5_intensity', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              ความพร้อมของห้องปฏิบัติการ เครื่องมืออุปกรณ์ทางวิทยาศาสตร์และสิ่งอำนวยความสะดวก
            </div>
            <Wysiwyg
                theme="3"
                :value="form.s2_p5_lab_readiness"
                @onChange="setFormField('s2_p5_lab_readiness', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              ประสบการณ์การทำงานร่วมกับภาคอุตสาหกรรมของทีมวิจัยของโครงการ
            </div>
            <Wysiwyg
                theme="3"
                :value="form.s2_p5_collab_exp"
                @onChange="setFormField('s2_p5_collab_exp', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              เทคโนโลยีที่เกี่ยวข้องในโครงการมีศักยภาพในการนำมาพัฒนาสู่เชิงพาณิชย์ (Proven technology with high for
              commercialization)
              เช่น มีผลการทดลองในระดับห้องปฏิบัติการ หรือมีผลิตภัณฑ์ต้นแบบแล้ว เป็นต้น
            </div>
            <Wysiwyg
                theme="3"
                :value="form.s2_p5_tech_involved"
                @onChange="setFormField('s2_p5_tech_involved', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              ผลลัพธ์ของโครงการ เช่น เกิดผลิตภัณฑ์ใหม่ที่มีมูลค่าเพิ่มสูง หรือกระบวนการผลิตใหม่ที่มีประสิทธิภาพสูง
              ซึ่งไม่เคยมีมาก่อนในระดับประเทศหรือภูมิภาค
            </div>
            <Wysiwyg
                theme="3"
                :value="form.s2_p5_project_result"
                @onChange="setFormField('s2_p5_project_result', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              เอกสารอ้างอิง หรือ ข้อมูล ที่แสดงถึงความสำเร็จของงานวิจัยที่ได้ดำเนินก่อนหน้านี้
            </div>
            <Wysiwyg
                theme="3"
                :value="form.s2_p5_reference"
                @onChange="setFormField('s2_p5_reference', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>

    </divcard>
    <divcard v-else>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            8. ขั้นตอนและขอบเขตการดำเนินโครงการ
          </div>
          <Wysiwyg
              theme="3"
              :value="form.s2_p6_project_scope"
              @onChange="setFormField('s2_p6_project_scope', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <!-- From 9 -->
    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            9. ขั้นตอนและขอบเขตการดำเนินโครงการ
          </div>
          <Wysiwyg
              theme="3"
              :value="form.s2_p6_project_scope"
              @onChange="setFormField('s2_p6_project_scope', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>
    <divcard v-else>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            9. ผลการดำเนินงาน
          </div>
          <Wysiwyg
              theme="3"
              :value="form.s2_result"
              @onChange="setFormField('s2_result', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../../components/input/TextField"
import TextArea from "../../../../components/input/TextArea"
import SwitchInset from "../../../../components/input/SwitchInset"
import AutoBox from "../../../../components/input/AutoBox"
import {eventBus, formatNumber, validateEmail} from "../../../../plugins/global-funcs"
import {mapState} from "vuex"
import Button from "@/components/input/Button.vue";
import Wysiwyg from "@/components/input/Wysiwyg.vue";

export default {
  name: "CFormProject_CR",
  components: {
    Wysiwyg,
    Button,
    TextField,
    TextArea,
    SwitchInset,
    AutoBox
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data() {
    return {
      formatNumber,
      form: {},
      private_sum: null,
      inkind_sum: null,
      incash_sum: null,
      scipark_sum: null,
      inkind_percent: null,
      incash_percent: null,
      scipark_percent: null,
      industryBusinesses: [
        'กลุ่มอุตสาหกรรมมุ่งเน้น (Flagship project)',
        'อุทยานวิทยาศาสตร์ภาคเหนือ (NSP) ข้าว',
        'อุทยานวิทยาศาสตร์ภาคตะวันออกเฉียงเหนือ (NESP) ไก่',
        'อุทยานวิทยาศาสตร์ภาคใต้ (STSP) ยางพารา',
        'กลุ่มอุตสาหกรรมด้านเทคโนโลยีสารสนเทศ เช่น IT software IOS Android, และ Digital content ต่าง ๆ (เชื่อมโยงถึงอุตสาหกรรมการผลิตการท่องเที่ยวและอุตสาหกรรมการออกแบบและสร้างสรรค์)',
        'กลุ่มอุตสาหกรรมด้านการแพทย์ และเทคโนโลยีชีวภาพ',
        'กลุ่มอุตสาหกรรมอาหาร',
        'กลุ่มอุตสาหกรรมด้านเทคโนโลยีพลังงานทดแทน สิ่งแวดล้อม และวัสดุด้านพลังงาน',
        'กลุ่มอุตสาหกรรมอื่นๆ ที่มีศักยภาพในการเติบโต เช่น อุตสาหกรรมเวชภัณฑ์(เครื่องสําอาง) อุตสาหกรรมโลจิสติกส์ และห่วงโซ่อุปทาน'
      ],
      apply_type_list: [
        'การแก้ไขปัญหาของกระบวนการผลิต',
        'ปรับปรุงประสิทธิภาพกระบวนการผลิต',
        'พัฒนาคุณภาพสินค้าให้ได้มาตรฐานสากล',
        'พัฒนาผลิตภัณฑ์ใหม่'
      ],
      interest_list: [
        'Service Platform',
        'Business Incubation',
        'IRTC',
        'Co-Research'
      ],
      emailRules: [
        (v) => !!v || "",
        (v) => validateEmail(v) || "อีเมลไม่ถูกต้อง",
      ],
      teams: [],
      team_head: [],
      team_manager: [],
      team_coordinate: [],
    }
  },
  watch: {
    form: {
      handler(newValue) {
        if (!newValue) {
          this.form = this.masterData.form_c.project_section
        } else {
          this.form = newValue;
        }

        if (this.form.s2_p3_addr_pid) {
          const province_id = parseInt(this.masterData.provinces.find(province => province.name === this.form.s2_p3_addr_pid).province_id)
          this.filteredDistricts = this.masterData.districts.filter(district => district.province_id === province_id)
        }

        if (this.form.s2_p3_addr_did) {
          const district_id = parseInt(this.masterData.districts.find(district => district.name === this.form.s2_p3_addr_did).district_id)
          this.filteredSubdistricts = this.masterData.subdistricts.filter(subdistrict => subdistrict.district_id === district_id)
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState({
      ProjectForm: state => state.CForm.ProjectForm,
      GeneralForm: state => state.CForm.GeneralForm
    }),
    isFinal() {
      return this.$route.query.doc_type && this.$route.query.doc_type === 'progress'
    }
  },
  created() {
    if (this.isSameId && !this.masterData.form_c) this.form = this.ProjectForm
    if (this.masterData.form_c) {
      this.form = this.masterData.form_c.project_section
      this.calculateBudgetProportion();

      this.team_head = this.masterData.form_c.project_head_team
      this.team_manager = this.masterData.form_c.project_manager_team
      this.team_coordinate = this.masterData.form_c.project_coordinate_team
    }
    eventBus.$on('cFormProject', () => {
      eventBus.$emit("cFormProjectSend", {
        ...this.form,
        project_head_team: this.team_head,
        project_manager_team: this.team_manager,
        project_coordinate_team: this.team_coordinate
      });
    })

  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val

      if (field === 's2_p3_addr_pid') {
        //get province_id from masterdata
        const province_id = parseInt(this.masterData.provinces.find(province => province.name === val).province_id)
        this.filteredDistricts = this.masterData.districts.filter(district => district.province_id === province_id)
        this.form.s2_p3_addr_did = '';
        this.form.s2_p3_addr_sdid = '';
      }

      if (field === 's2_p3_addr_did') {
        //get district_id from masterdata
        const district_id = parseInt(this.masterData.districts.find(district => district.name === val).district_id)
        this.filteredSubdistricts = this.masterData.subdistricts.filter(subdistrict => subdistrict.district_id === district_id)
      }
      this.$forceUpdate()
    },
    setTeamField(field, team, i, val) {
      team[i][field] = val;
      this.$forceUpdate();
      console.log('teams', team)
    },
    addMoreTeam(team_type, team) {
      team.push(
          {
            team_type: team_type,
          }
      )
      console.log('teams', team)
    },
    delTeam(index, team) {
      team.splice(index, 1)
    },
    calculateBudgetProportion() {
      let budgetList = this.masterData.form_c?.project_section_plan?.project_section_budget

      if (budgetList !== undefined && budgetList.length > 0) {
        let all_sum = budgetList.map(x => x.budget_sum).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.inkind_sum = budgetList.map(x => x.budget_in_kind).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.incash_sum = budgetList.map(x => x.budget_in_cash).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.private_sum = this.inkind_sum + this.incash_sum;
        this.scipark_sum = budgetList.map(x => x.budget_sci_park).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.inkind_percent = (this.inkind_sum * 100 / all_sum).toFixed(2)
        this.incash_percent = (this.incash_sum * 100 / all_sum).toFixed(2)
        this.scipark_percent = (this.scipark_sum * 100 / all_sum).toFixed(2)

      }
    },
    parseValue(value) {
      if (value) {
        try {
          return JSON.parse(value)
        } catch (e) {
          console.error('Error parsing s2_p4_prv_org_other', e);
          return [];
        }
      }
      return [];
    },
  }
}
</script>

<style scoped>

</style>